import { Component, OnDestroy, OnInit } from '@angular/core';
import { HwwHelpService, SchemaButton } from '../hww-help.service';
import { Subject, takeUntil } from 'rxjs';
import {
  excludedKeys,
  healthIndexData,
  wealthIndexData,
  wisdomIndexData,
} from '../contents/textStorage';
import { NgClass, NgFor } from '@angular/common';

@Component({
  selector: 'app-interactive-schema',
  templateUrl: './interactive-schema.component.html',
  styleUrls: ['./interactive-schema.component.scss'],
  imports: [NgClass, NgFor],
})
export class InteractiveSchemaComponent implements OnInit, OnDestroy {
  public SchemaButton = SchemaButton;
  private readonly destroy$: Subject<boolean> = new Subject<boolean>();

  public buttonsArr: string[] = [];

  public activeButton: SchemaButton = SchemaButton.PRIMARY;
  public activeTertiaryButtons!: string[];

  constructor(private hwwService: HwwHelpService) {}

  ngOnInit(): void {
    this.handleSubscriptions();
    this.activeTertiaryButtons = this.hwwService.activeTertiaryButtons;
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  private handleSubscriptions(): void {
    this.hwwService.activeButton
      .pipe(takeUntil(this.destroy$))
      .subscribe((button) => {
        this.activeButton = button;

        if (button === SchemaButton.PRIMARY) {
          this.buttonsArr.length = 0;
        }
        if (button === SchemaButton.LEFT) {
          this.buttonsArr = this.getCorrectKeys(healthIndexData);
        }
        if (button === SchemaButton.MIDDLE) {
          this.buttonsArr = this.getCorrectKeys(wealthIndexData);
        }
        if (button === SchemaButton.RIGHT) {
          this.buttonsArr = this.getCorrectKeys(wisdomIndexData);
        }
      });
  }

  public handleSchemaButtonClick(button: SchemaButton): void {
    if (this.hwwService.activeButton.getValue() !== button) {
      this.hwwService.activeButton.next(button);
      this.activeTertiaryButtons.length = 0;
    }
  }

  public handleTertiaryButtonClick(button: any): void {
    if (!this.activeTertiaryButtons.includes(button)) {
      this.activeTertiaryButtons.push(button);
    } else {
      const index = this.activeTertiaryButtons.indexOf(button);
      this.activeTertiaryButtons.splice(index, 1);
    }
  }

  private getCorrectKeys(obj: { [key: string]: string }): string[] {
    return Object.entries(obj)
      .filter(([key, value]) => !excludedKeys.includes(key))
      .map(([key, value]) => key);
  }
}
